import { render, staticRenderFns } from "./DefinitionTable.vue?vue&type=template&id=c9c299c6&scoped=true"
import script from "./DefinitionTable.vue?vue&type=script&lang=js"
export * from "./DefinitionTable.vue?vue&type=script&lang=js"
import style0 from "./DefinitionTable.vue?vue&type=style&index=0&id=c9c299c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9c299c6",
  null
  
)

export default component.exports